import { BackgroundImage, Button, Flex, Space } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { useKeycloakStore } from '../../../shared_stores';

export const LandingBase = () => {
  const { t } = useTranslation('common');
  const kcStore = useKeycloakStore();
  const navigate = useNavigate();
  return (
    <BackgroundImage
      style={{ height: '100svh', backgroundPositionX: '26%' }}
      src="../../../assets/img/blue_thorax.png"
    >
      <Flex
        direction={'row'}
        justify={'center'}
        style={{
          backgroundColor: '#192D50BF',
          height: '100%',
          color: 'var(--mantine-color-clinicalWhite-0)',
          padding: 'var(--mantine-spacing-md)',
        }}
      >
        <Flex direction={'column'} justify={'end'} style={{ maxWidth: 500 }}>
          <Outlet />

          <Flex direction={'column'} style={{ textAlign: 'center' }}>
            <Space h={'md'} />
            <p>
              {kcStore.authenticated ? t('logged_in_as') : t('login_question')}
            </p>
            {kcStore.authenticated ? (
              <Button
                variant="white-text"
                style={{
                  textDecoration: 'underline',
                  height: 'var(--mantine-spacing-lg)',
                }}
                onClick={() => void navigate(`/profile`)}
              >
                {kcStore.user?.email}
              </Button>
            ) : (
              <Button
                variant="white-text"
                style={{
                  textDecoration: 'underline',
                  height: 'var(--mantine-spacing-lg)',
                }}
                onClick={() =>
                  void navigate(`/login?redirectUri=${window.location}`)
                }
              >
                {t('login')}
              </Button>
            )}
            <Space h={'md'} />
          </Flex>
        </Flex>
      </Flex>
    </BackgroundImage>
  );
};
